
angular.module("group_import", [])

    .controller("GroupImportCtrl", ['$state', '$timeout', '$stateParams', 'Restangular', '$scope', '$rootScope', '$http', '$filter', 'modalService', '$uibModal', 'gridService', 'logService',
        function ($state, $timeout, $stateParams, Restangular, $scope, $rootScope, $http, $filter, modalService, $uibModal, gridService, logService) {
            $scope.genders = [{ id: 'M', name: $filter("translate")('persons.gender_male') }, { id: 'F', name: $filter("translate")('persons.gender_female') }, { id: 'N', name: $filter("translate")('persons.gender_neutral') }];
            $scope.totalPositions = 0;
            $scope.treatments = [];
            $scope.selectedRows = [];

            $scope.actions = function (rowEntity) {

                if (!rowEntity.PersonName || !rowEntity.PersonSurname) {
                    return [
                        { id: 'ignore', name: 'Sin cambios' },
                    ];
                } else if (!rowEntity.isDuplicate) {
                    return [
                        { id: 'add_person_and_position', name: 'Crear persona y asignar cargo' },
                        { id: 'ignore', name: 'Sin cambios' },
                    ];
                } else if (!rowEntity.PersonPositionId) {
                    return [
                        { id: 'add_person_and_position', name: 'Crear persona y asignar cargo' },
                        { id: 'add_position', name: 'Asignar cargo' },
                        { id: 'ignore', name: 'Sin cambios' },
                    ];
                } else {
                    return [
                        { id: 'add_person_and_position', name: 'Crear persona y asignar cargo' },
                        { id: 'add_position', name: 'Asignar cargo' },
                        { id: 'ignore', name: 'Sin cambios' },
                        { id: 'end_position', name: 'Finalizar cargo' }
                    ];
                };
            }

            $scope.rowFormatter = function( row ) {
                return row.entity.Duplicate  != null;
            };
            
            $scope.gridGroupImport = {
                // enableGridMenu: true,
                paginationPageSizes: [50, 100, 150],
                paginationPageSize: 50,
                enableScrollbars: false,
                enableRowSelection: true,
                enableSelectAll: true,
                onRegisterApi: function (gridApi) {
                    callbackFunctionGridResize(0);
                    this.gridApi = gridApi;
                    this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                    this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
                    this.gridApi.pagination.on.paginationChanged($scope, function () {
                        let expandedRows = gridApi.expandable.getExpandedRows().length;
                        // let visiblexpandedRows = gridApi.expandable.getExpandedRows().filterer(r=>r.entity.)
                        callbackFunctionGridResize(expandedRows);
                    });
                    this.gridApi.expandable.on.rowExpandedStateChanged($scope, function () {    
                        let expandedRows = gridApi.expandable.getExpandedRows().length;
                        callbackFunctionGridResize(expandedRows);
                    });
                },

                columnDefs: [
                    {
                        name: 'isDuplicate', displayName: " ", cellTemplate: '<div><span ng-if="row.entity.Duplicate != null"><i class="fas fa-exclamation-triangle"></i></span></div>', width: 30,
                    },
                    { name: 'GroupName', displayName: $filter('translate')('general.name')},
                    { name: 'PositionName', displayName: $filter('translate')('persons.position') },
                    { name: 'PersonName', displayName: $filter('translate')('general.name') },
                    { name: 'PersonSurname', displayName: $filter('translate')('persons.surname')},
                    { name: 'PersonLastname', displayName: $filter('translate')('persons.lastname')},
                    { name: 'Action', displayName: $filter('translate')('events.guests.actions'), width: 100, editableCellTemplate: 'ui-grid/dropdownEditor',
                        editDropdownValueLabel: 'name', cellFilter: 'mapAction', editDropdownOptionsFunction: function(rowEntity, colDef) {
                            return $scope.actions(rowEntity);
                        }, },
                    {
                        name: ' ',
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                    }
                ],
                expandableRowTemplate: 'app/common/group_import/expandable_row_group_import.html',
                rowTemplate: '<div ng-class="{ \'ui-grid-row-warning\': grid.appScope.rowFormatter( row ) }">' +
                    '  <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"  ui-grid-cell></div>' +
                    '</div>'
            
            };

            $scope.importOptions = function (groupRows) {

                $scope.totalPositions = groupRows.length;

                let index = 0;
                angular.forEach(groupRows, function (row) {
                    row.subGridOptions = {
                        columnDefs: [
                            { name: 'Gender', displayName: $filter('translate')('persons.gender') },
                        ],
                        data: [row]
                    }
                });
                $scope.gridGroupImport.data = groupRows.map((p) => p = { ...p, gridId: index++, isDuplicate: (p.Duplicate != null) });

                }

            // Callback functions para el gird
            let callbackFunctionRowSelected = function (row) {
                let addAll = row.length > 1;
                logService.debug(row)
                if (!addAll) { // Si solo hemos seleccionado uno 
                    var index = $scope.selectedRows.map(function (e) { return e.gridId; }).indexOf(row.entity.gridId);
                    if (index < 0) {
                        if (row.isSelected)
                            $scope.selectedRows.push(row.entity);
                    } else {
                            $scope.selectedRows.splice(index, 1);
                        }
                } else { //Si hemos seleccionado todos
                    logService.debug('los he selectionado a todos')
                         $scope.selectedRows.length = [];
                    if (row[0].isSelected) {
                        $scope.selectedRows = $scope.gridGroupImport.data.filter(e => e.gridId < $scope.gridGroupImport.paginationPageSize)
                    }
                  }
            }

            // Función a mano para gestionar el resize del grid
            let callbackFunctionGridResize = function (expandedRows) {
                expandedRows ? expandedRows = expandedRows : expandedRows = 0;
                let visibleRows = $scope.gridGroupImport.data.length - $scope.gridGroupImport.paginationPageSize * ($scope.gridGroupImport.paginationCurrentPage - 1);
                if (visibleRows > $scope.gridGroupImport.paginationPageSize) visibleRows = $scope.gridGroupImport.paginationPageSize;
                $scope.gridSize = visibleRows * 31 + expandedRows * 153 + 100;
            };

            // Acciones masivas 
            $scope.massiveIgnore = function () { $scope.selectedRows.forEach(r => r.Action = 'ignore') }
            $scope.massiveImport = function () {
                $scope.selectedRows.forEach(function (r) {
                    if (r.PersonName && r.PersonSurname) {
                        r.Action = 'add_person_and_position';
                    }
                })
            };
            $scope.massiveEndPosition = function () {
                $scope.selectedRows.forEach(function (r) {
                    if (r.isDuplicate && r.PersonPositionId) {
                        r.Action = 'end_position';
                    }
                })
            };
            $scope.massiveAddPosition = function () {
                $scope.selectedRows.forEach(function (r) {
                    if (r.isDuplicate) {
                        r.Action = 'add_position';
                    }
                })
            };

            $scope.import = function() {
                let groupPositions = [];
                angular.forEach($scope.gridGroupImport.data, function (row) {
                    let position: any = {};
                    angular.copy(row, position);
                    position.subGridOptions = null;
                    groupPositions.push(position);
                });

                let request = {
                    groupPositions: groupPositions,
                    person_type: "Authority"
                };

                Restangular.all('Groups').customPOST(request, "Import").then(function (result) {
                        $state.go('groups.list');
                });
            };
}])
.filter('mapGender', function() {
    let genderHash = {
        'M': 'Hombre',
        'F': 'Mujer',
        'N': 'Neutro'
    };

    return function(input) {
        if (!input){
            return '';
        } else {
            return genderHash[input];
        }
    };
})
.filter('mapAction', function() {
    let actionHash = {
        'add_person_and_position' : 'Crear persona y asignar cargo',
        'add_position': 'Asignar cargo',
        'end_position': 'Finalizar cargo',
        'ignore': 'Sin cambios',
    };

    return function(input) {
        if (!input){
            return '';
        } else {
            return actionHash[input];
        }
    };
});
